import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { PredefinedPatientGroupsUpdateSettingsModal } from './PredefinedPatientGroupsUpdateModal';

type PredefinedPatientGroupsUpdateModalOpenerRenderProps = { openModal: VoidFunction };

type PredefinedPatientGroupsUpdateModalOpenerProps = {
   children: (renderProps: PredefinedPatientGroupsUpdateModalOpenerRenderProps) => JSX.Element;
   patientGroup: PatientGroup;
};

export const PredefinedPatientGroupsUpdateModalOpener = (
   props: PredefinedPatientGroupsUpdateModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <PredefinedPatientGroupsUpdateSettingsModal patientGroup={props.patientGroup} onClose={closeModal} />
         ) : null}
      </>
   );
};
